module.exports = __webpack_public_path__ + "img/img_sensor_cadence.cb58869e.jpg";